import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=0fae5721&scoped=true&"
import script from "./currency.vue?vue&type=script&lang=js&"
export * from "./currency.vue?vue&type=script&lang=js&"
import style0 from "./currency.vue?vue&type=style&index=0&id=0fae5721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae5721",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fae5721')) {
      api.createRecord('0fae5721', component.options)
    } else {
      api.reload('0fae5721', component.options)
    }
    module.hot.accept("./currency.vue?vue&type=template&id=0fae5721&scoped=true&", function () {
      api.rerender('0fae5721', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/currency.vue"
export default component.exports